var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 11C1 5.7533 5.2533 1.5 10.5 1.5C15.7467 1.5 20 5.7533 20 11C20 16.2467 15.7467 20.5 10.5 20.5C5.2533 20.5 1 16.2467 1 11Z",
    stroke: "#0DA06E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.33301 7.83325L13.6663 14.1666M13.6663 7.83325L7.33301 14.1666",
    stroke: "#0DA06E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGreen);
export default __webpack_public_path__ + "static/media/close-green.e9fd910662583303fffc54aa66712368.svg";
export { ForwardRef as ReactComponent };